// extracted by mini-css-extract-plugin
export default {"mainContainer":"OtpHeaderStep_mainContainer__zdN6e","descriptionBold":"OtpHeaderStep_descriptionBold__LahWa"};